import React from 'react'
import  * as SaveResult from './SaveResultConstants';
import bootoast from '../../bootoast/bootoast';

export default function SaveAndNavigate({getDataHandler, navigateAway, cancelText, readOnlyMode}) {



    const saveData = async () =>{
        try{
            await getDataHandler.current.saveData(false);  
            navigateAway(SaveResult.SAVED_INCOMPLETE);
        }
        
        catch(err){
            bootoast.toast({
                position: 'left-top',
                message: `Error saving form, try again, and if you receive this messge please contact Central Support at centralsupport@pcrb.com`,
                type: 'danger',
                timeout: 7
              });
              console.log(err);
        }

    };
    
    return (
        <section id="nav-save-form-area">
            {!readOnlyMode && 
                <button type="button" className="btn btn-primary" id="save"  onClick={()=>saveData()}>Save form without completing</button>
            }

            {cancelText && 
                <button type="button" className="btn btn-primary" id="cancel" onClick={()=>navigateAway(SaveResult.CANCELLED)}>{cancelText}</button>
            }
        </section>
    )
}


